module.exports = __webpack_public_path__ + "img/1546423693.98ee8824.jpg";